/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * clarityrcm.api
 * OpenAPI spec version: 1.0
 */
import type {
  CcofCaptureInitiateResponse,
  CcofCaptureStaffRequest,
} from "../../../../../lib/api-types/schemas";

import { authenticatedClient } from "../../authenticatedClient";

/**
 * **Actor types:** `clinic`, `internal`

**Practice-scoped:** route `{practiceId}` must match the user's `practiceId` claims

Creates a Stripe SetupIntent on the practice's connected account and returns its client_secret for the FE to mount a Stripe Elements PaymentElement. No card data touches this backend.
 * @summary Initiates a staff-assisted card-on-file capture for a patient, scoped to the active practice.
 */
export type postApiCcofPracticeIdCaptureStaffResponse200 = {
  data: CcofCaptureInitiateResponse;
  status: 200;
};

export type postApiCcofPracticeIdCaptureStaffResponse400 = {
  data: void;
  status: 400;
};

export type postApiCcofPracticeIdCaptureStaffResponse401 = {
  data: void;
  status: 401;
};

export type postApiCcofPracticeIdCaptureStaffResponse403 = {
  data: void;
  status: 403;
};

export type postApiCcofPracticeIdCaptureStaffResponse404 = {
  data: void;
  status: 404;
};

export type postApiCcofPracticeIdCaptureStaffResponse409 = {
  data: void;
  status: 409;
};

export type postApiCcofPracticeIdCaptureStaffResponseSuccess =
  postApiCcofPracticeIdCaptureStaffResponse200 & {
    headers: Headers;
  };
export type postApiCcofPracticeIdCaptureStaffResponseError = (
  | postApiCcofPracticeIdCaptureStaffResponse400
  | postApiCcofPracticeIdCaptureStaffResponse401
  | postApiCcofPracticeIdCaptureStaffResponse403
  | postApiCcofPracticeIdCaptureStaffResponse404
  | postApiCcofPracticeIdCaptureStaffResponse409
) & {
  headers: Headers;
};

export const getPostApiCcofPracticeIdCaptureStaffUrl = (practiceId: string) => {
  return `/api/ccof/${practiceId}/capture/staff`;
};

export const postApiCcofPracticeIdCaptureStaff = async (
  practiceId: string,
  ccofCaptureStaffRequest: CcofCaptureStaffRequest,
  options?: RequestInit,
): Promise<postApiCcofPracticeIdCaptureStaffResponseSuccess> => {
  return authenticatedClient<postApiCcofPracticeIdCaptureStaffResponseSuccess>(
    getPostApiCcofPracticeIdCaptureStaffUrl(practiceId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(ccofCaptureStaffRequest),
    },
  );
};
